import React, { useEffect, useRef, useState } from 'react'

import useWindowSize from 'hooks/useWindowSize'
import classNames from 'classnames'
import './GuideTooltip.scss'
import { useTranslation } from 'react-i18next'

export const GuideTooltip = ({
    // continuous,
    index,
    step,
    skipProps,
    primaryProps,
    tooltipProps,
}: any) => {
    const tooltipRef = useRef<HTMLDivElement>(null)
    const [arrowPosition, setArrowPosition] = useState('50%')
    const { width } = useWindowSize()
    const { t } = useTranslation('productTour')
    console.log(step, arrowPosition)

    useEffect(() => {
        if (!tooltipRef.current) return

        const tooltipRect = tooltipRef.current.getBoundingClientRect()
        const windowWidth = window.innerWidth

        let newArrowPosition = '50%'

        if (tooltipRect.left < 20) {
            newArrowPosition = '20px'
        } else if (tooltipRect.right > windowWidth - 20) {
            newArrowPosition = 'calc(100% - 20px)'
        }

        setArrowPosition(newArrowPosition)
    }, [width])

    const indexStyles: Record<number, string> = {
        0: 'startStepContent',
        6: 'seventhStepContent',
        7: 'eighthStepContent',
    }

    return (
        <>
            <div
                key={index}
                ref={tooltipRef}
                className={classNames('wrapper', indexStyles[index], {
                    'arrow-right': step.placement === 'right',
                    'arrow-left': step.placement === 'left',
                    'arrow-top': step.placement === 'top',
                    'arrow-bottom': step.placement === 'bottom',
                })}
                {...tooltipProps}
            >
                <div className={classNames('content')}>
                    <div className='title'>{step.title}</div>
                    {step.content}
                    <div className='buttons'>
                        {index !== 21 && (
                            <button
                                type='button'
                                className='skip-btn'
                                {...skipProps}
                            >
                                {t('skip')}
                            </button>
                        )}

                        <button
                            type='button'
                            className='next-btn'
                            {...primaryProps}
                        >
                            {index === 21 ? t('done') : t('next')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
